import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import { initialValues } from "./values";
import { loginFormValidationSchema } from "./validation";
import Field from "../../../common/components/Field";
import { Grid, Button, Card, Fab, Typography } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import DateFnsUtils from "@date-io/date-fns";
import { Formik } from "formik";
import moment from "moment";

import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";

import styles from "./styles";

const renderDepartment = (formik, dataDepartments, count, arr) => {
  return (
    <Field
      inputLabel="Setor"
      options
      dataOptions={dataDepartments}
      name={`department[${count}]`}
      formik={formik}
    />
  );
};

const RegisterBi = ({ classes, onRequestSend, data, dataSub }) => {
  const [count, setCount] = useState(0);
  const [arr, setArr] = useState([]);
  const dataDepartments = [...data, ...dataSub];

  const [selectedDate, setSelectedDate] = useState(new Date(moment()));

  const [selectedHour, setSelectedHour] = useState(new Date(moment()));

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleHourChange = (date) => {
    setSelectedHour(date);
  };

  return (
    <Formik
      initialValues={initialValues()}
      validationSchema={loginFormValidationSchema}
    >
      {(formik) => (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Card
            style={{
              margin: "auto",
              padding: 10,
              display: "flex",
              maxWidth: 220,
              background: "#fff",
              flexDirection: "column",
            }}
          >
            <Grid container>
              <Grid item>
                <Field
                  formik
                  label="Descrição"
                  name="description"
                  formik={formik}
                />
                <Field
                  formik
                  label="ID do relatório"
                  name="reportId"
                  formik={formik}
                />
                <Field
                  inputLabel="Setor"
                  options
                  dataOptions={dataDepartments}
                  name="department[0]"
                  formik={formik}
                />
                {count > 0
                  ? arr.map((item) =>
                      renderDepartment(formik, dataDepartments, count)
                    )
                  : null}
              </Grid>
              <Grid item className={classes.buttonContent}></Grid>
            </Grid>
            <div style={{ flex: 1, justifyItems: "flex-end" }}>
              <Button
                onClick={() => {
                  setCount(count + 1);
                  setArr([...arr, count + 1]);
                }}
                size="small"
                className={classes.buttonAdd}
                aria-label="add"
              >
                <Add />
              </Button>
            </div>
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="dd/MM/yyyy"
              margin="normal"
              id="date-picker-inline"
              label="Dia para expiração"
              value={selectedDate}
              onChange={handleDateChange}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
            />
            <KeyboardTimePicker
              margin="normal"
              id="time-picker"
              label="Hora para expiração"
              value={selectedHour}
              onChange={handleHourChange}
              KeyboardButtonProps={{
                "aria-label": "change time",
              }}
            />
            <Button
              onClick={() =>
                onRequestSend(formik.values, selectedDate, selectedHour)
              }
              className={classes.button}
            >
              CADASTRAR
            </Button>
          </Card>
        </MuiPickersUtilsProvider>
      )}
    </Formik>
  );
};

export default withStyles(styles)(RegisterBi);
